export default "__VITE_ASSET__DlnGvxtL__"